export enum DmpHlGetInteropCodesEnum {
  healthcareSettings = 'healthcareSettings',
  practiceSettings = 'practiceSettings',
  activitySectors = 'activitySectors',
  docFormats = 'docFormats',
  docTypes = 'docTypes',
  professions = 'professions',
  physicianSpecialities = 'physicianSpecialities',
  pharmacistSpecialities = 'pharmacistSpecialities',
  dentistSpecialities = 'dentistSpecialities',
  docCategories = 'docCategories',
  docTypesToDocCategories = 'docTypesToDocCategories',
  docTypesTranslation = 'docTypesTranslation',
}
